import { render, staticRenderFns } from "./rtl.vue?vue&type=template&id=5a6db054"
import script from "./rtl.vue?vue&type=script&lang=js"
export * from "./rtl.vue?vue&type=script&lang=js"
import style0 from "./rtl.vue?vue&type=style&index=0&id=5a6db054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports